import React, { useRef, FC } from 'react';
import { Controller, Control, ControllerRenderProps } from 'react-hook-form';

import cls from 'classnames';

import Button from '@ott/button';
import FirstErrorShower from '@ott/first-error-shower';
import ArrowRightIcon from '@ott/icon-arrow-right';
import CheckIcon from '@ott/icon-check';
import { InputWithRef } from '@ott/input-next-deprecated';
import { l10n } from '@ott/l10n';

import { FORM_FIELDS } from '../../../../constants';
import { FormState } from '../../../../types';

import styles from './BannerSubscriptionForm.scss';

type Props = {
  alwaysShowMobileView?: boolean;
  className?: string;
  control: Control<any, any>;
  errors: Record<string, string>;
  isHidden: boolean;
  isSubmitted: boolean;
  isSuccess: boolean;
  onFormSubmit: (e?: React.BaseSyntheticEvent) => Promise<any>;
  setTime: (time: number) => void;
  time: number;
};

const SubscriptionForm: FC<Props> = (props) => {
  const formRef = useRef<HTMLFormElement>(null);

  const {
    alwaysShowMobileView,
    className,
    control,
    errors,
    isSubmitted,
    isSuccess,
    onFormSubmit,
    time,
  } = props;

  const inputRenderer = ({ field }: { field: ControllerRenderProps<FormState> }) => {
    return (
      <InputWithRef
        type="text"
        enableAutoComplete={true}
        autoCompleteName={FORM_FIELDS.EMAIL}
        placeholder={l10n('emailSubscription.form.placeholder')}
        size="small"
        className={styles.input}
        specificLocators="email-input"
        {...field}
      />
    );
  };

  if (isSuccess) {
    return (
      <div
        className={cls(styles.wrapper, styles.successWrapper, className)}
        data-locator="success-label"
      >
        {l10n('emailSubscription.success.label')}
        <CheckIcon />
      </div>
    );
  }

  return (
    <form ref={formRef} onSubmit={onFormSubmit} className={cls(styles.wrapper, className)}>
      <FirstErrorShower
        errors={errors}
        show={isSubmitted}
        container={formRef.current}
        time={time}
      />

      <Controller name={FORM_FIELDS.EMAIL} control={control} render={inputRenderer} />

      <Button
        type="submit"
        purpose="secondary"
        size="medium"
        className={cls(styles.button, { [styles.mobile]: alwaysShowMobileView })}
        specificLocators="submit-button"
      >
        <span className={styles.buttonAction}>{l10n('emailSubscription.form.button')}</span>
        <ArrowRightIcon className={styles.buttonArrow} />
      </Button>
    </form>
  );
};

export default SubscriptionForm;
